import React from 'react';
import ReactDOM from 'react-dom/client';
import './api/axiosAuth';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import initFacebookSDK from './hooks/facebook-hooks';
import { initAnalyticsScripts } from './utils/analytics';
import { loadDeferredThirdPartyScripts } from './utils/deferredThirdParty';
// import DiwaliEffects from './diwali/DiwaliEffects';
import IndependenceDayPlaneFormation from './App/app-root/component/IndependenceDayPlaneFormation';

const renderRoot = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      {/* <DiwaliEffects /> */}
      <IndependenceDayPlaneFormation fullScreen />
      <App />
    </React.StrictMode>
  );
}

// Render immediately so the app works even when ETP/ad blockers block Facebook SDK
renderRoot();

// Analytics stubs + script tags load async; must run before route tracker effects
initAnalyticsScripts();

// Init Facebook in background for login/share; do not block first paint
initFacebookSDK().catch(() => {
  // FB script blocked (e.g. Enhanced Tracking Protection) – app still works
});

loadDeferredThirdPartyScripts();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
